<div class="text-center mt-3">
  <h4 *ngIf="footerAuthService?.model?.titulo" class="titulo-h4 texto-lato texto-extra-bold texto-inter">{{ footerAuthService?.model?.titulo }}</h4>
  <p *ngIf="footerAuthService?.model?.subTitulo" class="texto-2 texto-secundario texto-regular texto-inter" style="margin: 12px;">{{ footerAuthService?.model?.subTitulo }}</p>
  <div class="d-flex justify-content-center align-items-center">
    <button class="botao-lg botao-primario-outline texto-inter texto-semi-bold" *ngIf="footerAuthService?.model?.buttonLink?.ativo" [routerLink]="footerAuthService?.model?.buttonLink?.routerLink">
      {{ footerAuthService?.model?.buttonLink?.label }}
    </button>
  </div>
</div>
